import React, { createContext, useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import PropTypes from "prop-types";
import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";

import { db, auth } from "../firebase/firebase";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(true);
  const [role, setRole] = useState("")

  const createUser = (email, password) => {
    setLoading(true);
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const loginUser = (email, password) => {
    setLoading(true);
    return signInWithEmailAndPassword(auth, email, password);
  };

  const logOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
    }
  };
  const getUserPermissions = async (uid) => {
    const userRef = doc(db, "departments", uid); // Replace collection() with doc() to get the document reference
    const docSnap = await getDoc(userRef); // Use getDoc to fetch the document

    if (!docSnap.exists()) {
      throw new Error("User not found");
      
    }

    const userData = docSnap.data();

    setRole(userData.role)
    // Check if the role exists
    if (!userData.permissions) {
      throw new Error("No Permissions is Given to User");
    }

    return userData.permissions;
  };
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUser(user);
        setLoading(false);
      }
      else{
        setUser(null);
        setLoading(false);

      }
    });

    return () => unsubscribe();
  }, []);

  const authValue = {
    createUser,
    user,
    getUserPermissions,
    loginUser,
    logOut,
    role,
    loading,
  };

  return (
    <AuthContext.Provider value={authValue}>{children}</AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default AuthProvider;
